import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Dish } from 'src/services/classes/models/dish';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';

@Component({
  selector: 'app-dish-items',
  templateUrl: './dish-items.component.html',
  styleUrls: ['./dish-items.component.scss'],
})
export class DishItemsComponent implements OnInit {
  @Input() dishItems: Dish[] = [];
  @Output() itemSelected = new EventEmitter<Dish>();

  constructor(private notifyService: NotificationsService) {}

  ngOnInit(): void {}

  selectItem(food: Dish) {
    if (food?.stockCount > 0) {
      this.itemSelected.emit(food);
    } else {
      this.notifyService.publishMessages(
        'Item is currently unavailable',
        'warning',
        1
      );
    }
  }

  parseNumber(count: any) {
    return parseInt(count);
  }

  isImageValid(control: string) {
    return /^(ftp|https|http)?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/.test(
      control
    );
  }
}
